import React, { useMemo, useState } from 'react';
import { featuredLocations, LocationLink, LocationColumn } from '../../../data/featuredLocations';
import { ChevronDown } from 'lucide-react';

interface LocationSection {
    title: string;
    items: LocationLink[];
}

export function Locations() {
    const [open, setOpen] = useState(false);

    const locationSections: LocationSection[] = useMemo(
        () =>
            featuredLocations.map((stateGroup: LocationColumn) => ({
                title: stateGroup.state,
                items: stateGroup.locations,
            })),
        []
    );

    return (
        <section className="bg-[#F9FBFB] pt-5">
            <div className="googlelp-container">
                <div className="flex align-center md:justify-center justify-left pt-3 md:pt-0">
                    <button
                        type="button"
                        className="w-100 mx-auto block relative md:pr-12 bg-transparent border-none pl-0 pt-0 pb-0 cursor-pointer outline-none text-left md:text-center"
                        aria-expanded={open}
                        aria-controls="googlelp-locations-grid"
                        aria-label={open ? 'Hide featured locations' : 'Show featured locations'}
                        onClick={() => setOpen((s) => !s)}
                    >
                        <h2 className="mcl-font-greycliff md:pl-12 m-0 inline-block text-center">Featured Locations</h2>
                        <ChevronDown
                            className={`absolute right-0 top-1/2 transform -translate-y-1/2 transition-transform w-8 h-8 md:w-12 md:h-12 ${open ? 'rotate-180' : ''}`}
                            aria-hidden
                        />
                    </button>
                </div>

                <ul
                    id="googlelp-locations-grid"
                    className={`grid grid-flow-rows auto-rows-max-content grid-rows-none h-auto md:grid-cols-3 gap-12 pt-9 md:pt-10 pl-0 pb-5 md:pb-12 mb-0 ${open ? 'max-h-[4000px] opacity-1' : 'overflow-hidden max-h-[0px]  opacity-0 transition-all duration-300 ease-in-out'}`}
                >
                    {locationSections.map((section: LocationSection, id: number) => (
                        <li key={id}>
                            <span className="mcl-font-proxima font-bold flex pb-3 text-lg/6">{section.title}</span>
                            <ul className="pl-0">
                                {section.items.map((location: LocationLink, locId: number) => (
                                    <li key={locId} className="pb-2 pl-0 underline text-base/6">
                                        <a href={location.href} target="_blank" rel="noopener noreferrer">
                                            {location.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}

export default Locations;
